import React from 'react';
import { observer } from 'mobx-react';
import { Trans, useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { Typography } from 'antd';
import { CHAT_STATUS, LANGUAGES_TYPES } from '../../../../constants';
import { useStore } from '../../../../store/rootStore';
import blankProfilePicture from '../../../../assets/avatars/blankProfilePicture.png';
import styles from './SystemMessage.module.scss';
const { Text } = Typography;
const AvatarSlot = () => (React.createElement("img", { className: styles.systemMessageAvatar, src: blankProfilePicture, alt: "avatar" }));
const DepartmentColor = ({ department }) => {
    const backgroundColor = typeof department === 'object' ? department.color || 'white' : 'white';
    return React.createElement("div", { style: { backgroundColor }, className: styles.systemMessageDepartmentColor });
};
const departmentName = (department) => typeof department === 'object' ? department.name : department;
const SystemMessage = ({ newChatStatus, assignedToAgent, agent, time, assignedToDepartment, }) => {
    const { i18n, t } = useTranslation();
    const store = useStore();
    const resolveAgent = (uid) => {
        if (!uid)
            return t('externalSystem');
        const found = store.agentsStore.users.find((u) => u._id === uid);
        return (found === null || found === void 0 ? void 0 : found.displayName) || uid;
    };
    const resolveDepartment = (id) => {
        return store.departmentsStore.departments.find((d) => d._id === id) || id;
    };
    const buildTransProps = () => {
        const isSelfAssign = assignedToAgent && assignedToAgent === agent;
        if (newChatStatus === CHAT_STATUS.PENDING) {
            if (assignedToAgent && assignedToDepartment) {
                const department = resolveDepartment(assignedToDepartment);
                return {
                    key: 'toAssignedAgentDepartmentSystemMessage',
                    components: { avatar: React.createElement(AvatarSlot, null), color: React.createElement(DepartmentColor, { department: department }) },
                    values: {
                        assignedTo: resolveAgent(assignedToAgent),
                        department: departmentName(department),
                        agent: resolveAgent(agent),
                    },
                };
            }
            if (assignedToAgent) {
                return {
                    key: 'toAssignedSystemMessage',
                    components: { avatar: React.createElement(AvatarSlot, null) },
                    values: { assignedTo: resolveAgent(assignedToAgent), agent: resolveAgent(agent) },
                };
            }
            if (assignedToDepartment) {
                const department = resolveDepartment(assignedToDepartment);
                return {
                    key: 'toAssignedDepartmentSystemMessage',
                    components: { color: React.createElement(DepartmentColor, { department: department }) },
                    values: { assignedTo: departmentName(department), agent: resolveAgent(agent) },
                };
            }
            return { key: 'toPendingSystemMessage', values: { agent: resolveAgent(agent) } };
        }
        if (newChatStatus === CHAT_STATUS.ASSIGNED && assignedToAgent) {
            if (isSelfAssign && assignedToDepartment) {
                const department = resolveDepartment(assignedToDepartment);
                return {
                    key: 'toSelfAssignedSystemMessageWithDepartment',
                    components: { avatar: React.createElement(AvatarSlot, null), color: React.createElement(DepartmentColor, { department: department }) },
                    values: { assignedTo: resolveAgent(assignedToAgent), department: departmentName(department) },
                };
            }
            if (isSelfAssign) {
                return {
                    key: 'toSelfAssignedSystemMessage',
                    components: { avatar: React.createElement(AvatarSlot, null) },
                    values: { assignedTo: resolveAgent(assignedToAgent) },
                };
            }
            return {
                key: 'toAssignedSystemMessage',
                components: { avatar: React.createElement(AvatarSlot, null) },
                values: { assignedTo: resolveAgent(assignedToAgent), agent: resolveAgent(agent) },
            };
        }
        if (newChatStatus === CHAT_STATUS.RESOLVED) {
            return {
                key: 'toResolvedSystemMessage',
                components: { avatar: React.createElement(AvatarSlot, null) },
                values: { agent: resolveAgent(agent) },
            };
        }
        if (newChatStatus === CHAT_STATUS.BOT) {
            return { key: 'toBotSystemMessage', values: { agent: resolveAgent(agent) } };
        }
        if (newChatStatus === CHAT_STATUS.BULK) {
            return { key: 'toBulkSystemMessage', values: { agent: resolveAgent(agent) } };
        }
        return null;
    };
    const trans = buildTransProps();
    const textClassName = classnames(styles.systemMessageTextInner, {
        [styles.reverseText]: i18n.language === LANGUAGES_TYPES.HE,
    });
    return (React.createElement("div", { className: styles.systemMessageWrapper },
        React.createElement("div", { className: styles.systemMessageText }, trans && (React.createElement(Text, { className: textClassName },
            React.createElement(Trans, { i18nKey: trans.key, components: trans.components, values: trans.values })))),
        React.createElement("p", { className: styles.systemMessageTime }, time)));
};
export default observer(SystemMessage);
